<template lang='pug'>
section
  v-card
    v-toolbar(flat color='white')
      h2(class='title font-weight-medium') Отделы
      v-spacer
      v-btn(@click='dialog = true' small flat)
        v-icon(left) add
        | Добавить отдел
    v-divider
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer'  @click='onEdit(props.item)')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Название офиса') {{ props.item.office_name }}
          td(data-label='Название отдела') {{ props.item.department_name }}
          td(data-label='Адрес') {{ props.item.address_full }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(@click.stop='onDelete(props.item)' icon)
              v-icon(small) delete_outline
  s-link-departments(
    :dialog='dialog'
    @select='onAdd'
    :managerId='managerId'
    @close='dialog = false'
  )
</template>

<script>
import http from '@/http'

export default {
  props: ['managerId'],

  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Название офиса',
        align: 'left',
        value: 'office_name',
        width: '25%',
        sortable: false
      },
      {
        text: 'Название отдела',
        align: 'left',
        value: 'department_name',
        width: '25%',
        sortable: false
      },
      {
        text: 'Адрес',
        align: 'left',
        value: 'address_full',
        width: '50%',
        sortable: false
      },
      { text: '', align: 'left', width: '0%', sortable: false }
    ],
    isLoading: false,
    dialog: false,
    count: 100,
    list: []
  }),

  created() {
    this.fetch()
  },

  methods: {
    onEdit({ id, office_id }) {
      this.$router.push({
        name: 'Admin.Offices.Departments.Edit',
        params: {
          departmentId: id,
          id: office_id
        }
      })
    },

    async onAdd({ id }) {
      this.dialog = false

      try {
        await http.post(`/admin/departments/${id}/manager/add`, {
          managers: [this.managerId]
        })

        this.fetch()
      } catch (e) {
        this.$root.showSnack('Не удалось добавить менеджера в отдел')
      }
    },

    async onDelete({ id }) {
      if (await this.$confirm('Удалить менеджера из отдела?')) {
        try {
          await http.post(`/admin/departments/${id}/manager/delete`, {
            managers: [this.managerId]
          })

          this.fetch()
        } catch (e) {
          this.$root.showSnack('Не удалось удалить менеджера из отдела')
        }
      }
    },

    async fetch() {
      this.isLoading = true

      try {
        this.list = (await http.get('/admin/departments', {
          params: {
            manager_id: this.managerId,
            count: this.count
          }
        })).data.data
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить список отделов')
      }

      this.isLoading = false
    }
  }
}
</script>
